import Inputmask from 'inputmask/dist/inputmask.es6'
import moment from 'moment'
import 'daterangepicker'
import lang from '@/plugins/lang'
import { dateFormat } from '@/helpers/dateHelper'

$('.daterange-datepicker').each(function() {
    let options = {
        autoUpdateInput: false,
        autoApply: true,
        linkedCalendars: false,
        locale: {
            applyLabel: lang.t('daterangerpicker:apply'),
            cancelLabel: lang.t('daterangerpicker:cancel'),
            fromLabel: lang.t('daterangerpicker:from'),
            toLabel: lang.t('daterangerpicker:to'),
            format: dateFormat().moment.dateTime,
            customRangeLabel: lang.t('daterangerpicker:customRangeLabel'),
        },
        alwaysShowCalendars: true,
    }

    if (this.classList.contains('daterange-long-ranges')) {
        options.ranges = {
            [lang.t('daterangerpicker:ranges.last_7_days')]: [moment().subtract(6, 'days'), moment()],
            [lang.t('daterangerpicker:ranges.last_30_days')]: [moment().subtract(29, 'days'), moment()],
            [lang.t('daterangerpicker:ranges.current_month')]: [moment().startOf('month'), moment().endOf('month')],
            [lang.t('daterangerpicker:ranges.last_month')]: [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
            [lang.t('daterangerpicker:ranges.current_year')]: [moment().startOf('year'), moment().endOf('year')],
            [lang.t('daterangerpicker:ranges.last_year')]: [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')],
        }
    }

    $(this).daterangepicker(options)
        .on('apply.daterangepicker', function(ev, picker) {
            $(this).val(picker.startDate.format(dateFormat().moment.date) + ' - ' + picker.endDate.format(dateFormat().moment.date));
        })
        .on('cancel.daterangepicker', function() {
            $(this).val('');
        })
        .data('daterangepicker').container.removeClass('auto-apply')

    Inputmask({
        alias: 'datetime',
        inputFormat: dateFormat().inputMask.date + ' - ' + dateFormat().inputMask.date,
        placeholder: dateFormat().placeholder.date + ' - ' + dateFormat().placeholder.date,
        clearMaskOnLostFocus: false,
        autoUnmask: true,
        removeMaskOnSubmit: true,
        onUnMask: function(maskedValue, unmaskedValue) {
            return unmaskedValue ? maskedValue : unmaskedValue
        },
    }).mask(this)
})
